import React from 'react'
import type { NavMenuItem } from './Header'
import { getTopNavMenuItems } from './topNavContent'

const INITIAL_RETRY_INTERVAL_MS = 30000
const MAX_RETRY_INTERVAL_MS = 5 * 60 * 1000

function getRetryDelay(attempt: number): number {
  return Math.min(INITIAL_RETRY_INTERVAL_MS * Math.pow(2, attempt), MAX_RETRY_INTERVAL_MS)
}

export function useTopNavMenuItems(themeBrand: string): NavMenuItem[] | null {
  const [apiMenuItems, setApiMenuItems] = React.useState<NavMenuItem[] | null>(null)

  React.useEffect(() => {
    let isMounted = true
    let retryTimeout: ReturnType<typeof setTimeout> | null = null
    let attempt = 0

    const loadMenuItems = async () => {
      const apiItems = await getTopNavMenuItems(themeBrand)
      if (!isMounted) return

      if (apiItems && apiItems.length > 0) {
        setApiMenuItems(apiItems)
        attempt = 0
        return
      }

      setApiMenuItems(null)
      retryTimeout = setTimeout(() => {
        if (isMounted) {
          attempt += 1
          loadMenuItems()
        }
      }, getRetryDelay(attempt))
    }

    loadMenuItems()

    return () => {
      isMounted = false
      if (retryTimeout) {
        clearTimeout(retryTimeout)
      }
    }
  }, [themeBrand])

  return apiMenuItems
}
